import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT, LIMIT_PAGE  } from "constants/variables";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box';  
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import MenuItem  from "@mui/material/MenuItem"; 
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types';
import TableSortingPurchseStore from 'pages/purchases/editOrNewPurchaseDelivery/SortingTablesPurchseSheet'; 

const initialFiltersSheet= {
  "idFrom":"",
  "idTo":"",
  "numberSheetFrom":"",
  "numberSheetTo":"",
  "dateSheetFrom":null,
  "dateSheetTo":null,
  "marcaFrom":"",
  "marcaTo":"",
  "modeloFrom":"",
  "modeloTo":"",
  "licensePlateSheetFrom":"",
  "licensePlateSheetTo":"",
  "frameSheetFrom":"",
  "frameSheetTo":""
};
 
const initialStateSHEET = [{
   "id" : "",
  "ownsheet_id" : "", 
  "num_sheet":"",
  "date_sheet":"",
  "vehicle_marca":"",
  "vehicle_model":"",
  "vehicle_sheet":"",
  "frame_sheet":""
}];
 
const initialMarcaToSelect = [{
  "id": "",
  "marca": ""
}];

const initialModelToSelect = [{
  "id": "",
  "model": ""
}];
 
       
const PurchaseSearchSHEETS = ({ showModalSearchSHEETS, setShowModalSearchSHEETS,setFormPurchaseDelivery}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const state = useSelector((state) => state);
  const {token} = state.loginUser
  const [dataSHEET, setDataSHEET] = useState(initialStateSHEET);
  const [isLoadingErrorSHEET, setIsLoadingErrorSHEET] = useState(false);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [inputTextSHEET, setInputTextSHEET] = useState("");
  const [applyFiltersSHEET, setApplyFiltersSHEET]= useState(initialFiltersSheet);
  const [filtersSHEET, setFiltersSHEET]= useState(initialFiltersSheet);
  const [openEditFilterSHEET,setOpenEditFilterSHEET]= useState(false);
  const [errorsFiltersSHEET, seterrorsFiltersSHEET] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegSHEET,setNumTotRegSHEET]= useState(0);
  const [activeOffsetSHEET, setActiveOffsetSHEET]= useState(false);
  const [currencyOffsetSHEET, setCurrencyOffsetSHEET] = useState(0);
  const [rangeOffsetSHEET, setRangeOffsetSHEET] = useState([{}]); 
  const [marcaToSelect,setMarcaToSelect]= useState(initialMarcaToSelect); 
  const [filteredMarcaFrom, setFilteredMarcaFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexMarcaFrom, setHighlightedIndexMarcaFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredMarcaTo, setFilteredMarcaTo] = useState([]); // Opciones filtradas
  const [highlightedIndexMarcaTo, setHighlightedIndexMarcaTo] = useState(-1); // Índice de la opción resaltada
  const [modelToSelect,setModelToSelect]= useState(initialModelToSelect); 
  const [filteredModelFrom, setFilteredModelFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexModelFrom, setHighlightedIndexModelFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredModelTo, setFilteredModelTo] = useState([]); // Opciones filtradas
  const [highlightedIndexModelTo, setHighlightedIndexModelTo] = useState(-1); // Índice de la opción resaltada
  const dispatch = useDispatch(); 
   
  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && setShowModalSearchSHEETS) {
        setDataSHEET(initialStateSHEET);
        setIsLoadingErrorSHEET(false); 
        setInputTextSHEET("");
        setApplyFiltersSHEET(initialFiltersSheet);
        setFiltersSHEET(initialFiltersSheet);
        setOpenEditFilterSHEET(false);
        seterrorsFiltersSHEET({});
        setNumTotRegFilter(0);
        setNumTotRegSHEET(0);
        setActiveOffsetSHEET(false);
        setCurrencyOffsetSHEET(0);
        setRangeOffsetSHEET([{}]);
        setMarcaToSelect(initialMarcaToSelect);
        setFilteredMarcaFrom([]);
        setHighlightedIndexMarcaFrom(-1); 
        setFilteredMarcaTo([]);  
        setHighlightedIndexMarcaTo(-1);   
        setModelToSelect(initialModelToSelect);
        setFilteredModelFrom([]);
        setHighlightedIndexModelFrom(-1); 
        setFilteredModelTo([]);  
        setHighlightedIndexModelTo(-1);  
        setShowModalSearchSHEETS(false);
      }
    },
    [ setDataSHEET,
      setIsLoadingErrorSHEET, 
      setInputTextSHEET,
      setApplyFiltersSHEET,
      setFiltersSHEET,
      setOpenEditFilterSHEET,
      seterrorsFiltersSHEET,
      setNumTotRegFilter,
      setNumTotRegSHEET,
      setActiveOffsetSHEET,
      setCurrencyOffsetSHEET,
      setRangeOffsetSHEET,
      setShowModalSearchSHEETS
    ]
  );

  const handleCloseDataEditSHEET = () => {
    setDataSHEET(initialStateSHEET);
    setIsLoadingErrorSHEET(false);
    setInputTextSHEET("");
    setApplyFiltersSHEET(initialFiltersSheet);
    setFiltersSHEET(initialFiltersSheet);
    setOpenEditFilterSHEET(false);
    seterrorsFiltersSHEET({});
    setNumTotRegFilter(0);
    setNumTotRegSHEET(0);
    setActiveOffsetSHEET(false);
    setCurrencyOffsetSHEET(0);
    setRangeOffsetSHEET([{}]);
    setMarcaToSelect(initialMarcaToSelect);
    setFilteredMarcaFrom([]);
    setHighlightedIndexMarcaFrom(-1); 
    setFilteredMarcaTo([]);  
    setHighlightedIndexMarcaTo(-1);   
    setModelToSelect(initialModelToSelect);
    setFilteredModelFrom([]);
    setHighlightedIndexModelFrom(-1); 
    setFilteredModelTo([]);  
    setHighlightedIndexModelTo(-1);  
    setShowModalSearchSHEETS(false)
	};

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };

  // Dentro del componente
  const debouncedHandleSearchMarcaFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredMarcaFrom([]);
      setHighlightedIndexMarcaFrom(-1);
      return;
    }
    const filtered = marcaToSelect
      .filter(vehicletype => vehicletype && vehicletype.marca)
      .filter(vehicletype => {
        const marcaFROM = vehicletype.marca.toUpperCase();
        return marcaFROM.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredMarcaFrom(filtered);
      setHighlightedIndexMarcaFrom(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectMarcaFrom = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      marcaFrom: vehicletype.marca || "",
      marcaTo: vehicletype.marca || filtersSHEET.marcaTo,
    })); 
    setFilteredMarcaFrom([]);
    setHighlightedIndexMarcaFrom(-1);
  }; 
  
  const handleKeyDownMarcaFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredMarcaFrom.length === 0 && filtersSHEET.marcaFrom.trim() === "") {
        setFilteredMarcaFrom(marcaToSelect);
        setHighlightedIndexMarcaFrom(0);
      } else {
        setHighlightedIndexMarcaFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredMarcaFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexMarcaFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexMarcaFrom >= 0) {
      if (highlightedIndexMarcaFrom >= 0 && highlightedIndexMarcaFrom < filteredMarcaFrom.length) {
        handleSelectMarcaFrom(filteredMarcaFrom[highlightedIndexMarcaFrom]);
      }
    } else if (event.key === "Escape") {
      const isValid = marcaToSelect.some((vehicletype) => {
        if (!vehicletype || !vehicletype.marca) return false; 
        const normalizedMarca = vehicletype.marca.toUpperCase();
        const normalizedInputMarca = filtersSHEET.marcaFrom.toUpperCase();
        return normalizedMarca === normalizedInputMarca;
      }); 
      if (!isValid) {
        setFiltersSHEET(filtersSHEET => ({
          ...filtersSHEET,
          marcaFrom: "" 
        })); 
      }
      setFilteredMarcaFrom([]);
      setHighlightedIndexMarcaFrom(-1);
    }
  }; 
  
  // Dentro del componente
  const debouncedHandleSearchMarcaTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredMarcaTo([]);
      setHighlightedIndexMarcaTo(-1);
      return;
    }
    const filtered = marcaToSelect
      .filter(vehicletype=>(vehicletype.marca>=filtersSHEET.marcaFrom))
      .filter(vehicletype => vehicletype && vehicletype.marca)
      .filter(vehicletype => {
        const marca = vehicletype.marca.toUpperCase();
        return marca.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredMarcaTo(filtered);
    setHighlightedIndexMarcaTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectMarcaTo = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFiltersSHEET(filtersSHEET => ({
    ...filtersSHEET,
    marcaTo:  vehicletype.marca || ""
  }));
  setFilteredMarcaTo([]);
  setHighlightedIndexMarcaTo(-1);
  }; 
  const handleKeyDownMarcaTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredMarcaTo.length === 0 && filtersSHEET.marcaTo.trim() === "") {
        const filtered = marcaToSelect.filter(item=>(item.marca>=filtersSHEET.marcaFrom));
        setFilteredMarcaTo(filtered);
        setHighlightedIndexMarcaTo(0);
      } else {
        setHighlightedIndexMarcaTo((prevIndex) => {
          const nextIndex = prevIndex < filteredMarcaTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexMarcaTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexMarcaTo >= 0) {
      if (highlightedIndexMarcaTo >= 0 && highlightedIndexMarcaTo < filteredMarcaTo.length) {
        handleSelectMarcaTo(filteredMarcaTo[highlightedIndexMarcaTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = marcaToSelect
      .filter(item=>(item.marca>=filtersSHEET.marcaFrom))
      .some((vehicletype) => {
      if (!vehicletype || !vehicletype.marca) return false; 
        const normalizedMarca = vehicletype.tradename.toUpperCase();
        const normalizedInputMarca = filtersSHEET.marcaTo.toUpperCase();
        return normalizedMarca === normalizedInputMarca;
    }); 
    if (!isValid) {
      setFiltersSHEET(filtersSHEET => ({
        ...filtersSHEET,
        marcaTo:  ""
      }));
    }
    setFilteredMarcaTo([]);
    setHighlightedIndexMarcaTo(-1);
    }
  }; 
  
  // Dentro del componente
  const debouncedHandleSearchModelFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredModelFrom([]);
      setHighlightedIndexModelFrom(-1);
      return;
    }
    const filtered = modelToSelect
      .filter(vehicletype => vehicletype && vehicletype.model)
      .filter(vehicletype => {
        const model = vehicletype.model.toUpperCase(); 
        return model.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredModelFrom(filtered);
    setHighlightedIndexModelFrom(0);
  }, 300); 
  // Manejo de la selección de una tienda
    const handleSelectModelFrom = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      modeloFrom: vehicletype.model || "",
      modeloTo: vehicletype.model || filtersSHEET.modeloTo 
    }));
    setFilteredModelFrom([]);
    setHighlightedIndexModelFrom(-1);
  }; 
  const handleKeyDownModelFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredModelFrom.length === 0 && filtersSHEET.modeloFrom.trim() === "") {
        setFilteredModelFrom(modelToSelect);
        setHighlightedIndexModelFrom(0);
      } else {
        setHighlightedIndexModelFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredModelFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexModelFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexModelFrom >= 0) {
      if (highlightedIndexModelFrom >= 0 && highlightedIndexModelFrom < filteredModelFrom.length) {
        handleSelectModelFrom(filteredModelFrom[highlightedIndexModelFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = modelToSelect.some((vehicletype) => {
        if (!vehicletype || !vehicletype.model) return false; 
        const normalizedModel = vehicletype.model.toUpperCase();
        const normalizedInputModel = filtersSHEET.modeloFrom.toUpperCase();
        return normalizedModel === normalizedInputModel;
      }); 
      if (!isValid) {
        setFiltersSHEET(filtersSHEET => ({
          ...filtersSHEET,
          modelFrom: ""
        }));
      }
      setFilteredModelFrom([]);
      setHighlightedIndexModelFrom(-1);
    }
  };
  
  // Dentro del componente
  const debouncedHandleSearchModelTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredModelTo([]);
      setHighlightedIndexModelTo(-1);
      return;
    }
    const filtered = modelToSelect
      .filter(vehicletype=>(vehicletype.model>=filtersSHEET.modelFrom))
      .filter(vehicletype => vehicletype && vehicletype.model)
      .filter(vehicletype => {
        const model = vehicletype.model.toUpperCase();
        return model.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredModelTo(filtered);
    setHighlightedIndexModelTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectModelTo = (vehicletype) => {
    if (!vehicletype) return; // Validación adicional para evitar errores
    setFiltersSHEET(filtersSHEET => ({
    ...filtersSHEET,
    modelTo:  vehicletype.model || ""
  }));
  setFilteredModelTo([]);
  setHighlightedIndexModelTo(-1);
  }; 
  const handleKeyDownModelTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredModelTo.length === 0 && filtersSHEET.modeloTo.trim() === "") {
        const filtered = modelToSelect.filter(item=>(item.model>=filtersSHEET.modelFrom));
        setFilteredModelTo(filtered);
        setHighlightedIndexModelTo(0);
      } else {
        setHighlightedIndexModelTo((prevIndex) => {
          const nextIndex = prevIndex < filteredModelTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexModelTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexModelTo >= 0) {
      if (highlightedIndexModelTo >= 0 && highlightedIndexModelTo < filteredModelTo.length) {
        handleSelectModelTo(filteredModelTo[highlightedIndexModelTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = modelToSelect
      .filter(item=>(item.model>=filtersSHEET.modelFrom))
      .some((vehicletype) => {
      if (!vehicletype || !vehicletype.model) return false; 
        const normalizedModel = vehicletype.tradename.toUpperCase();
        const normalizedInputModel = filtersSHEET.modelTo.toUpperCase();
        return normalizedModel === normalizedInputModel;
    }); 
    if (!isValid) {
      setFiltersSHEET(filtersSHEET => ({
        ...filtersSHEET,
        modeloTo:  ""
      }));
    }
    setFilteredMarcaTo([]);
    setHighlightedIndexMarcaTo(-1);
    }
  }; 
  
  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) { 
      setHighlightedIndexMarcaFrom(-1); 
      setFilteredMarcaFrom([]);
      setHighlightedIndexMarcaTo(-1); 
      setFilteredMarcaTo([]); 
      setHighlightedIndexModelFrom(-1); 
      setFilteredModelFrom([]);
      setHighlightedIndexModelTo(-1); 
      setFilteredModelTo([]);  
    }
  }, []); 
  
  const toggleDrawerSearchFormSHEET  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditSHEET();
    }
  };

  let inputHandlerSHEET = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextSHEET(lowerCase);
  };

  const openEditFiltersSHEET = () => {
    setFiltersSHEET(applyFiltersSHEET);
    setOpenEditFilterSHEET(!openEditFilterSHEET);
  };

  const toggleDrawerFilterEditSHEET = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditSHEET();
    }
  };

  const handleCancelfiltersSHEET = () => {
    seterrorsFiltersSHEET({});
    setFiltersSHEET(initialFiltersSheet);
    setOpenEditFilterSHEET(!openEditFilterSHEET);
  };

  const handleChangeFilterEditSHEET = (e) => {
    const { name, value } = e.target;
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      [name]: value
    }));
  };

  const handleBlurFilterEditSHEET = (e) => {
    seterrorsFiltersSHEET(validateFormFilterSHEET());
    handleChangeFilterEditSHEET(e);
  };
  
  const handleSubmitFilterEditSHEET = () => {
    seterrorsFiltersSHEET(validateFormFilterSHEET());
    if (Object.keys(errorsFiltersSHEET).length === 0) {
      setApplyFiltersSHEET(filtersSHEET);
      setFiltersSHEET(initialFiltersSheet);
      seterrorsFiltersSHEET({});
      setOpenEditFilterSHEET(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeletefiltersSHEET = () => {
    seterrorsFiltersSHEET({});
    setFiltersSHEET(initialFiltersSheet);
    setApplyFiltersSHEET(initialFiltersSheet);
    setOpenEditFilterSHEET(!openEditFilterSHEET);
  };

  const handleChangeSelectDateSheetFrom = (event) => {
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      dateSheetFrom: event!==null?new Date(event):null,
      dateSheetTo:null
    }));
  };
 
  const handleBlurSelectDateSheetFrom = (e) => {
    handleChangeSelectDateSheetFrom(e);
    seterrorsFiltersSHEET(validateFormFilterSHEET());
  };

  const handleChangeSelectDateSheetTo = (event) => {
    setFiltersSHEET(filtersSHEET => ({
      ...filtersSHEET,
      dateSheetTo: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDateSheetTo = (e) => {
    handleChangeSelectDateSheetTo(e);
    seterrorsFiltersSHEET(validateFormFilterSHEET());
  };
   
  const validateFormFilterSHEET = () => {

    let errorsFiltersSHEET = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersSHEET.idFrom!=="" & !regexNumber.test(filtersSHEET.idFrom)) {
      errorsFiltersSHEET.idFrom = 'Text_TextNoNumber';
    }
    if (filtersSHEET.idTo!=="" & !regexNumber.test(filtersSHEET.idTo)) {
      errorsFiltersSHEET.idTo = 'Text_TextNoNumber';
    }
    if (filtersSHEET.idFrom!=="" & !errorsFiltersSHEET.idFrom!==undefined){
      if (filtersSHEET.idTo!=="" & !errorsFiltersSHEET.idTo!==undefined){
        if (parseInt(filtersSHEET.idTo)<parseInt(filtersSHEET.idFrom)){
          errorsFiltersSHEET.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersSHEET.numberSheetFrom)) {
      errorsFiltersSHEET.numberSheetFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.numberSheetTo)) {
      errorsFiltersSHEET.numberSheetTo = 'Text_TextNoValid';
    }
      
    if (regexInvalidCharacters.test(filtersSHEET.marcaFrom)) {
      errorsFiltersSHEET.marcaFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.marcaTo)) {
      errorsFiltersSHEET.marcaTo = 'Text_TextNoValid';
    }

    if (regexInvalidCharacters.test(filtersSHEET.modeloFrom)) {
      errorsFiltersSHEET.modeloFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.modeloTo)) {
      errorsFiltersSHEET.modeloTo = 'Text_TextNoValid';
    }

    if (regexInvalidCharacters.test(filtersSHEET.licensePlateSheetFrom)) {
      errorsFiltersSHEET.licensePlateSheetFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.licensePlateSheetTo)) {
      errorsFiltersSHEET.licensePlateSheetTo = 'Text_TextNoValid';
    }

     if (regexInvalidCharacters.test(filtersSHEET.frameSheetFrom)) {
      errorsFiltersSHEET.frameSheetFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersSHEET.frameSheetTo)) {
      errorsFiltersSHEET.frameSheetTo = 'Text_TextNoValid';
    }
  
    if (filtersSHEET.numberSheetTo!=="" & filtersSHEET.numberSheetTo<filtersSHEET.numberSheetFrom){
      errorsFiltersSHEET.numberSheetTo = 'Text_TextGreater_NumberSheet';
    }

     if (filtersSHEET.marcaTo!=="" & filtersSHEET.marcaTo<filtersSHEET.marcaFrom){
      errorsFiltersSHEET.marcaTo = 'Text_TextGreater_MarcaSheet';
    }

    if (filtersSHEET.modeloTo!=="" & filtersSHEET.modeloTo<filtersSHEET.modeloFrom){
      errorsFiltersSHEET.modeloTo = 'Text_TextGreater_ModelSheet';
    }

    if (filtersSHEET.licensePlateSheetTo!=="" & filtersSHEET.licensePlateSheetTo<filtersSHEET.licensePlateSheetFrom){
      errorsFiltersSHEET.licensePlateSheetTo = 'Text_TextGreater_LicensePlateSheet';
    }

    if (filtersSHEET.frameSheetTo!=="" & filtersSHEET.frameSheetTo<filtersSHEET.frameSheetFrom){
      errorsFiltersSHEET.frameSheetTo = 'Text_TextGreater_FrameSheet';
    }

    return errorsFiltersSHEET;
  }  

  const filtereddataSHEET = dataSHEET.filter((el) => {
    if (inputTextSHEET === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') + 
        String(el.num_sheet || '') + 
        String(el.vehicle_marca || '') + 
        String(el.vehicle_model || '') + 
        String(el.vehicle_sheet || '') +  
        String(el.frame_sheet || '');
      let result = dataTranslate.toLowerCase().includes(inputTextSHEET.toLowerCase());
      return result; 
    }
  })


  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
  useEffect(() => {
    let isMounted = true; 
    const fetchDataVehiclesMarca = async () => {
      try {
        const getData = await helpHttp().get5(ENDPOINT,`purchasedelivery/getlistvehicletypesmarca`,token,
          filtersSHEET.marcaFrom!==undefined && filtersSHEET.marcaFrom!==null && filtersSHEET.marcaFrom.replace(/[.\-/\\|]/g, "").trim()!==""?filtersSHEET.marcaFrom.replace(/[.\-/\\|]/g, ""):"-1",
          filtersSHEET.marcaTo!==undefined && filtersSHEET.marcaTo!==null && filtersSHEET.marcaTo.replace(/[.\-/\\|]/g, "").trim()!==""?filtersSHEET.marcaTo.replace(/[.\-/\\|]/g, ""):"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setMarcaToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   
    if (showModalSearchSHEETS ) { 
      fetchDataVehiclesMarca();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,filtersSHEET,openEditFilterSHEET,showModalSearchSHEETS]);
    
  useEffect(() => {
    let isMounted = true; 
    const fetchDataVehiclesMarca = async () => {
      try {
        const getData = await helpHttp().get5(ENDPOINT,`purchasedelivery/getlistvehicletypesmodel`,token,
          filtersSHEET.modeloFrom!==undefined && filtersSHEET.modeloFrom!==null && filtersSHEET.modeloFrom.replace(/[.\-/\\|]/g, "").trim()!==""?filtersSHEET.modeloFrom.replace(/[.\-/\\|]/g, ""):"-1",
          filtersSHEET.modeloTo!==undefined && filtersSHEET.modeloTo!==null && filtersSHEET.modeloTo.replace(/[.\-/\\|]/g, "").trim()!==""?filtersSHEET.modeloTo.replace(/[.\-/\\|]/g, ""):"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setModelToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   
    if (showModalSearchSHEETS) { 
      fetchDataVehiclesMarca();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,filtersSHEET,openEditFilterSHEET,showModalSearchSHEETS]);
    
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegSHEET = async () => {
      try { 
        const getData = await helpHttp().get(ENDPOINT, `purchasedelivery/getinformationtablepurchasesheet`, token);
        if (getData.err) {
          setDataSHEET(initialStateSHEET);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegSHEET(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
 
    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post(ENDPOINT,`purchasedelivery/getcountfilterpurchasesheet`,token,applyFiltersSHEET);
        if (getData.err || getData.message === "Load failed") {
          setDataSHEET(initialStateSHEET);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchdataSHEET = async () => { 
      try {
        const getData = await helpHttp().get3(ENDPOINT,`purchasedelivery/getpurchasesheet`,token,currencyOffsetSHEET,LIMIT_PAGE,applyFiltersSHEET);
        if (getData.err || getData.message === "Load failed") {
          setDataSHEET(initialStateSHEET);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataSHEET(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    
    if (showModalSearchSHEETS){
      fetchnumTotRegSHEET();
      fetchnumTotRegFilter();
      fetchdataSHEET();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,applyFiltersSHEET,currencyOffsetSHEET,showModalSearchSHEETS]);
 

  return(
    <>
      {showModalSearchSHEETS && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormSHEET(false)}
            onOpen={toggleDrawerSearchFormSHEET(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'1300px', width: '1100px'}}>
                <div id="myDIV">
                  <h1 className="h1NewStyle mb-2">
                  {isLoadingErrorSHEET?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_SHEET_Searchs')}</h1>
                    <div>
                      <button type="button" className="buttonCreate" onClick={handleCloseDataEditSHEET}>{t('Button_Exit')}</button><> </>
                    </div> 
                </div>  
                <br/>
                <div className="searchStyle">
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    value={inputTextSHEET}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                    placeholder={t('Text_SHEET_Search')} 
                    onChange={inputHandlerSHEET}
                    fullWidth
                    label={t('Text_SHEET_Search')}>
                  </TextField>
                </div>
                <br/>
                <div id="myNewDIV">
                  <h1 className="filter-title">{t('Text_Filter')}</h1> 
                  <div className="filter-buttons"> 
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersSHEET}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersSHEET.idFrom!==null || applyFiltersSHEET.idTo!==null )?"#32CD32":"#FFFFFF"}}></i> {t('Text_Code')}</button><> </> 
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersSHEET}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersSHEET.licensePlateSheetFrom!=="" || applyFiltersSHEET.licensePlateSheetTo!=="")?"#32CD32":"#FFFFFF"}}></i> {t('Text_SHEET_LICENSEPLATE')}</button><> </> 
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersSHEET}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersSHEET.marcaFrom!=="" || applyFiltersSHEET.marcaTo!=="")?"#32CD32":"#FFFFFF"}}></i> {t('Text_SHEET_MARCA')}</button><> </> 
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersSHEET}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersSHEET.modeloFrom!=="" || applyFiltersSHEET.modeloTo!=="")?"#32CD32":"#FFFFFF"}}></i> {t('Text_SHEET_MODEL')}</button><> </> 
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersSHEET}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersSHEET.frameSheetFrom!=="" || applyFiltersSHEET.frameSheetTo!=="")?"#32CD32":"#FFFFFF"}}></i> {t('Text_SHEET_FRAME')}</button><> </> 
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersSHEET}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersSHEET.numberSheetFrom!=="" || applyFiltersSHEET.numberSheetTo!=="")?"#32CD32":"#FFFFFF"}}></i> {t('Text_SHEET_NUM')}</button><> </>
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersSHEET}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersSHEET.dateSheetFrom!==null || applyFiltersSHEET.dateSheetTo!==null )?"#32CD32":"#FFFFFF"}}></i> {t('Text_SHEET_DATE')}</button><> </> 
                  </div>
                </div> 
                <br/>
                {!isLoadingData ?
                  <>
                    <div className="card shadow mb-4">    
                      <div className="card-body">
                        <TableSortingPurchseStore
                          dataSHEET={filtereddataSHEET}
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={t('Text_SHEET_table')}
                          numTotRegSHEET={numTotRegSHEET}
                          activeOffsetSHEET={activeOffsetSHEET}
                          rangeOffsetSHEET={rangeOffsetSHEET}
                          currencyOffsetSHEET={currencyOffsetSHEET}
                          setCurrencyOffsetSHEET={setCurrencyOffsetSHEET} 
                          setFormPurchaseDelivery={setFormPurchaseDelivery}
                          handleCloseDataEditSHEET={handleCloseDataEditSHEET}
                        >
                        </TableSortingPurchseStore>
                      </div>             
                    </div>
                    {openEditFilterSHEET &&
                      <div>
                      <SwipeableDrawer
                        anchor='right'
                        open={true}
                        onClose={toggleDrawerFilterEditSHEET(false)}
                        onOpen={toggleDrawerFilterEditSHEET(true)}>
                        <Container >
                          <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                            <br/>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form className="newfilterformstore" onSubmit={handleCancelfiltersSHEET}>  
                                <div className="form-floating mb-3 px-4 primary">
                                  <div className="form-group"> 
                                    <TextField
                                      id="idFrom" 
                                      name="idFrom"
                                      value={filtersSHEET.idFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersSHEET.idFrom!=null?t(errorsFiltersSHEET.idFrom):t('Text_Filter_Code_From')}
                                      placeholder={t('PlaceHolder_Filter_Code_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditSHEET}
                                      onChange={handleChangeFilterEditSHEET}/>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                      <TextField
                                      id="idTo" 
                                      name="idTo"
                                      value={filtersSHEET.idTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersSHEET.idTo!=null?t(errorsFiltersSHEET.idTo):t('Text_Filter_Code_To')}
                                      placeholder={t('PlaceHolder_Filter_Code_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditSHEET}
                                      onChange={handleChangeFilterEditSHEET}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="licensePlateSheetFrom" 
                                      name="licensePlateSheetFrom"
                                      value={filtersSHEET.licensePlateSheetFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                                      label={errorsFiltersSHEET.licensePlateSheetFrom!=null?t(errorsFiltersSHEET.licensePlateSheetFrom):t('Text_Filter_LicensePlateSheet_From')}
                                      placeholder={t('PlaceHolder_Filter_LicensePlateSheet_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditSHEET}
                                      onChange={handleChangeFilterEditSHEET}
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="licensePlateSheetTo" 
                                      name="licensePlateSheetTo"
                                      value={filtersSHEET.licensePlateSheetTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                                      label={errorsFiltersSHEET.licensePlateSheetTo!=null?t(errorsFiltersSHEET.licensePlateSheetTo):t('Text_Filter_LicensePlateSheet_To')}
                                      placeholder={t('PlaceHolder_Filter_LicensePlateSheet_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditSHEET}
                                      onChange={handleChangeFilterEditSHEET}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <span style={{ position: "relative" }}>
                                      <TextField
                                        id="marcaFrom"
                                        name="marcaFrom"
                                        value={filtersSHEET.marcaFrom}
                                        onChange={(e) => {
                                          setFiltersSHEET(prev => ({
                                            ...prev,
                                            marcaFrom: e.target.value.toUpperCase(),
                                            marcaTo: e.target.value.toUpperCase()
                                          }));
                                          debouncedHandleSearchMarcaFrom(e.target.value);
                                        }}
                                        onKeyDown={handleKeyDownMarcaFrom}
                                        onBlur={(event) => {
                                          if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            handleBlur();
                                          }
                                        }}
                                        label={errorsFiltersSHEET.marcaFrom != null
                                          ? t(errorsFiltersSHEET.marcaFrom)
                                          : t('Text_Filter_MarcaSheet_From')}
                                        placeholder={t('PlaceHolder_Filter_MarcaSheet_From')}
                                        inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                        InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                        variant="outlined"
                                      />
                                      {filteredMarcaFrom.length > 0 && (
                                        <div
                                          className="dropdown-class"
                                          style={{
                                            position: "absolute",
                                            left: '0px',
                                            border: "2px solid #4e73df",
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "100%",
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa",
                                            zIndex: 1000,
                                          }}
                                          onMouseDown={(e) => e.preventDefault()}
                                        >
                                          {filteredMarcaFrom.map((vehicletype, index) => (
                                            <MenuItem
                                              key={vehicletype.id}
                                              onClick={() => handleSelectMarcaFrom(vehicletype)}
                                              style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor: index === highlightedIndexMarcaFrom ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexMarcaFrom ? "white" : "black",
                                              }}
                                            >
                                              {vehicletype.marca}
                                            </MenuItem>
                                          ))}
                                        </div>
                                      )} 
                                      </span>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <span style={{ position: "relative" }} >
                                        <TextField
                                          id="marcaTo"
                                          name="marcaTo"
                                          value={filtersSHEET.marcaTo}
                                          onChange={(e) => {
                                            setFiltersSHEET(prev => ({
                                              ...prev,
                                              marcaTo: e.target.value.toUpperCase()
                                            }));
                                            debouncedHandleSearchMarcaTo(e.target.value);
                                          }}
                                          onKeyDown={handleKeyDownMarcaTo}
                                          onBlur={(event) => {
                                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                              handleBlur();
                                            }
                                          }}
                                          label={errorsFiltersSHEET.marcaTo != null
                                            ? t(errorsFiltersSHEET.marcaTo)
                                            : t('PlaceHolder_Filter_MarcaSheet_To')}
                                          placeholder={t('PlaceHolder_Filter_MarcaSheet_To')}
                                          inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                          InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                          variant="outlined"
                                      />
                                      {filteredMarcaTo.length > 0 && (
                                        <div
                                          className="dropdown-class"
                                          style={{
                                            position: "absolute",
                                            left: '0px',
                                            border: "2px solid #4e73df",
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "100%",
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa",
                                            zIndex: 1000,
                                          }}
                                          onMouseDown={(e) => e.preventDefault()}
                                        >
                                          {filteredMarcaTo.map((vehicletype, index) => (
                                            <MenuItem
                                              key={vehicletype.id}
                                              onClick={() => handleSelectMarcaTo(vehicletype)}
                                              style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor: index === highlightedIndexMarcaTo ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexMarcaTo ? "white" : "black",
                                              }}
                                            >
                                              {vehicletype.marca} 
                                            </MenuItem>
                                          ))}
                                        </div>
                                      )}
                                    </span>  
                                  </div>

                                  <div className="form-group">
                                    <span style={{ position: "relative" }}>
                                      <TextField
                                        id="modeloFrom"
                                        name="modeloFrom"
                                        value={filtersSHEET.modeloFrom}
                                        onChange={(e) => {
                                          setFiltersSHEET(prev => ({
                                            ...prev,
                                            modeloFrom: e.target.value.toUpperCase(),
                                            modeloTo: e.target.value.toUpperCase()
                                          }));
                                          debouncedHandleSearchModelFrom(e.target.value);
                                        }}
                                        onKeyDown={handleKeyDownModelFrom}
                                        onBlur={(event) => {
                                          if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            handleBlur();
                                          }
                                        }}
                                        label={errorsFiltersSHEET.modeloFrom != null
                                          ? t(errorsFiltersSHEET.modeloFrom)
                                          : t('Text_Filter_ModelSheet_From')}
                                        placeholder={t('PlaceHolder_Filter_ModelSheet_From')}
                                        inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                        InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                        variant="outlined"
                                      />
                                      {filteredModelFrom.length > 0 && (
                                        <div
                                          className="dropdown-class"
                                          style={{
                                            position: "absolute",
                                            left: '0px',
                                            border: "2px solid #4e73df",
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "100%",
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa",
                                            zIndex: 1000,
                                          }}
                                          onMouseDown={(e) => e.preventDefault()}
                                        >
                                          {filteredModelFrom.map((vehicletype, index) => (
                                            <MenuItem
                                              key={vehicletype.id}
                                              onClick={() => handleSelectModelFrom(vehicletype)}
                                              style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor: index === highlightedIndexModelFrom ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexModelFrom ? "white" : "black",
                                              }}
                                            >
                                              {vehicletype.model}
                                            </MenuItem>
                                          ))}
                                        </div>
                                      )} 
                                      </span>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <span style={{ position: "relative" }} >
                                        <TextField
                                          id="modeloTo"
                                          name="modeloTo"
                                          value={filtersSHEET.modeloTo}
                                          onChange={(e) => {
                                            setFiltersSHEET(prev => ({
                                              ...prev,
                                              modeloTo: e.target.value.toUpperCase()
                                            }));
                                            debouncedHandleSearchModelTo(e.target.value);
                                          }}
                                          onKeyDown={handleKeyDownModelTo}
                                          onBlur={(event) => {
                                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                              handleBlur();
                                            }
                                          }}
                                          label={errorsFiltersSHEET.modeloTo != null
                                            ? t(errorsFiltersSHEET.modeloTo)
                                            : t('PlaceHolder_Filter_ModelSheet_To')}
                                          placeholder={t('PlaceHolder_Filter_ModelSheet_To')}
                                          inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                          InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                          variant="outlined"
                                      />
                                      {filteredModelTo.length > 0 && (
                                        <div
                                          className="dropdown-class"
                                          style={{
                                            position: "absolute",
                                            left: '0px',
                                            border: "2px solid #4e73df",
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "100%",
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa",
                                            zIndex: 1000,
                                          }}
                                          onMouseDown={(e) => e.preventDefault()}
                                        >
                                          {filteredModelTo.map((vehicletype, index) => (
                                            <MenuItem
                                              key={vehicletype.id}
                                              onClick={() => handleSelectModelTo(vehicletype)}
                                              style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor: index === highlightedIndexModelTo ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexModelTo ? "white" : "black",
                                              }}
                                            >
                                              {vehicletype.model} 
                                            </MenuItem>
                                          ))}
                                        </div>
                                      )}
                                    </span>  
                                  </div>
                                  
                                  <div className="form-group">
                                    <TextField
                                      id="frameSheetFrom" 
                                      name="frameSheetFrom"
                                      value={filtersSHEET.frameSheetFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                                      label={errorsFiltersSHEET.frameSheetFrom!=null?t(errorsFiltersSHEET.frameSheetFrom):t('Text_Filter_FrameSheet_From')}
                                      placeholder={t('PlaceHolder_Filter_FrameSheet_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditSHEET}
                                      onChange={handleChangeFilterEditSHEET}
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="frameSheetTo" 
                                      name="frameSheetTo"
                                      value={filtersSHEET.frameSheetTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                                      label={errorsFiltersSHEET.frameSheetTo!=null?t(errorsFiltersSHEET.frameSheetTo):t('Text_Filter_FrameSheet_To')}
                                      placeholder={t('PlaceHolder_Filter_FrameSheet_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditSHEET}
                                      onChange={handleChangeFilterEditSHEET}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="numberSheetFrom" 
                                      name="numberSheetFrom"
                                      value={filtersSHEET.numberSheetFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                      label={errorsFiltersSHEET.numberSheetFrom!=null?t(errorsFiltersSHEET.numberSheetFrom):t('Text_Filter_NumberSheet_From')}
                                      placeholder={t('PlaceHolder_Filter_NumberSheet_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditSHEET}
                                      onChange={handleChangeFilterEditSHEET}
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="numberSheetTo" 
                                      name="numberSheetTo"
                                      value={filtersSHEET.numberSheetTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                                      label={errorsFiltersSHEET.numberSheetTo!=null?t(errorsFiltersSHEET.numberSheetTo):t('Text_Filter_NumberSheet_To')}
                                      placeholder={t('PlaceHolder_Filter_NumberSheet_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditSHEET}
                                      onChange={handleChangeFilterEditSHEET}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                      <DesktopDatePicker
                                        id="dateSheetFrom" 
                                        name="dateSheetFrom"
                                        value={ filtersSHEET.dateSheetFrom!== null ? new Date(filtersSHEET.dateSheetFrom): null}
                                        format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                        label={errorsFiltersSHEET.dateSheetFrom!=null?t(errorsFiltersSHEET.dateSheetFrom):t('PlaceHolder_Filter_DateEntrySheet_From')}
                                        onBlur={handleBlurSelectDateSheetFrom}
                                        onChange={handleChangeSelectDateSheetFrom}
                                        slotProps={{
                                          textField: {
                                            placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                            sx: {
                                              color: '#1565c0',
                                              maxLength: '100',
                                              width: 430,  
                                              fontSize: '18px'
                                            },
                                            InputProps: {
                                              style: {
                                                fontSize: '18px',
                                              }
                                            },
                                            InputLabelProps:{ 
                                              style: {
                                                fontSize: '18px', 
                                                background: '#FFFFFF'
                                              }
                                            },
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                      <DesktopDatePicker
                                        id="dateSheetTo" 
                                        name="dateSheetTo"
                                        minDate={filtersSHEET.dateSheetFrom!== null ? new Date(filtersSHEET.dateSheetFrom): null}
                                        value={ filtersSHEET.dateSheetTo!== null ? new Date(filtersSHEET.dateSheetTo): null}
                                        format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                        label={errorsFiltersSHEET.dateSheetTo!=null?t(errorsFiltersSHEET.dateSheetTo):t('PlaceHolder_Filter_DateEntrySheet_To')}
                                        onBlur={handleBlurSelectDateSheetTo}
                                        onChange={handleChangeSelectDateSheetTo}
                                        slotProps={{
                                          textField: {
                                            placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                            sx: {
                                              color: '#1565c0',
                                              maxLength: '100',
                                              width: 430,  
                                              fontSize: '18px'
                                            },
                                            InputProps: {
                                              style: {
                                                fontSize: '18px',
                                              }
                                            },
                                            InputLabelProps:{ 
                                              style: {
                                                fontSize: '18px', 
                                                background: '#FFFFFF'
                                              }
                                            },
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </div> 
                                </div>
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <div className="btn-group d-grid d-md-flex justify-content-md-end" role="group">
                                  <button className="btn btn-primary btn-lg custom-btn" type="button" onClick={handleSubmitFilterEditSHEET}>{t('Button_Apply')}</button><> </>
                                  <button className="btn btn-outline-secondary btn-lg custom-btn" type="button" onClick={handleDeletefiltersSHEET}>{t('Button_Cancel_Filters')}</button>
                                </div>
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }   
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                }               
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

PurchaseSearchSHEETS.propTypes = {
  showModalSearchSHEETS: PropTypes.bool.isRequired,
  setShowModalSearchSHEETS: PropTypes.func.isRequired, 
  setFormPurchaseDelivery: PropTypes.func.isRequired
};

export default PurchaseSearchSHEETS;
